import React, {
	createRef,
	forwardRef, Fragment, useCallback, useState,
} from 'react';
import PropTypes from 'prop-types';
import styles from './styles.css';
import { Button } from '../Button/Button';
import { IconButton } from '../Button/IconButton';
import { ReactComponent as PublishIcon } from '../../assets/icons/Publish.svg?component';

let instanceCounter = 0;

const UploadButton = forwardRef(({
	accept,
	children,
	className,
	onChange,
	style,
	label,
	useIcon,
}, ref) => {
	const [id] = useState(`UploadButton-${++instanceCounter}`);
	const inputRef = createRef();
	const handleClick = useCallback((event) => {
		event.target.value = null;
	}, []);
	return (
		<>
			<input
				accept={accept}
				className={styles.input}
				id={id}
				onChange={onChange}
				onClick={handleClick}
				type="file"
				ref={inputRef}
			/>
			{useIcon
				? <IconButton icon={<PublishIcon />} tooltip={label} className={className} ref={ref} style={style} onClick={() => inputRef.current.click()} />
				: (
					<Button
						className={className}
						ref={ref}
						style={style}
						variant="contained"
						onClick={() => inputRef.current.click()}
					>
						{children || label}
					</Button>
				)}
		</>
	);
});

UploadButton.propTypes = {
	accept: PropTypes.string.isRequired,
	children: PropTypes.node,
	className: PropTypes.string,
	color: PropTypes.oneOf(['default', 'primary', 'secondary']),
	fullWidth: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	style: PropTypes.object,
	label: PropTypes.string.isRequired,
	useIcon: PropTypes.bool,
};

UploadButton.defaultProps = {
	className: undefined,
	color: 'default',
	fullWidth: false,
	style: undefined,
	useIcon: false,
	children: undefined,
};

export default UploadButton;
